function joinPath(...args) {
    return args.map(part => (part.endsWith('/') ? part.slice(0, -1) : part)).join('/');
}
function buildV3Path(apiBaseUrl, version, endpoint, ...rest) {
    return joinPath(apiBaseUrl, version, endpoint, ...rest);
}
export function buildPublicMapUrl({ apiBaseUrl, cartoMapId }) {
    return buildV3Path(apiBaseUrl, 'v3', 'maps', 'public', cartoMapId);
}
export function buildStatsUrl({ attribute, apiBaseUrl, connectionName, source, type }) {
    if (type === 'query') {
        return buildV3Path(apiBaseUrl, 'v3', 'stats', connectionName, attribute);
    }
    // type === 'table'
    return buildV3Path(apiBaseUrl, 'v3', 'stats', connectionName, source, attribute);
}
export function buildSourceUrl({ apiBaseUrl, connectionName, endpoint }) {
    return buildV3Path(apiBaseUrl, 'v3', 'maps', connectionName, endpoint);
}
export function buildQueryUrl({ apiBaseUrl, connectionName }) {
    return buildV3Path(apiBaseUrl, 'v3', 'sql', connectionName, 'query');
}
